import wretch from 'wretch'

import { api } from './api'
import { PLATFORM_API_URL } from './constants'

const platformClient = wretch()
  .content('application/json')
  .catcher('AbortError', () => {})
  .catcher(400, (err) => {
    console.error('Platform API 400: ', err)
    throw err
  })
  .catcher(401, (err) => {
    console.error('Platform API 401: ', err)
    throw err
  })
  .catcher(500, (err) => {
    console.error('Platform API 500: ', err)
    throw err
  })
  .catcher(504, (err) => {
    console.error('Platform API 504: timeout', err)
    throw err
  })

export const platformApi = {
  withAuth() {
    const token = api.getToken()
    return platformClient.auth(`Bearer ${token}`).url(PLATFORM_API_URL ?? '')
  },
}

/** SWR fetcher for platform-api — returns response.data directly (no gzip). */
export const platformAuthFetcher = <T>(url: string): Promise<T> =>
  platformApi
    .withAuth()
    .url(url)
    .get()
    .json<{ data: T }>()
    .then((resp) => resp.data)
